import { HttpClient, HttpErrorResponse, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { IParkerImportErrors, IParkerProfileDetail } from 'src/app/shared/interfaces';
import { environment } from 'src/environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    observe: 'events',
    responseType: 'text',
    userName: 'kmoss',
  }),
};

const httpSpaceOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  }),
};

@Injectable()
export class FileService {
  baseUrl: string = '';
  fileUrl = 'file';

  constructor(private http: HttpClient) {
    this.baseUrl = environment.RestServer;
  }

  public uploadParkerProfile(
    formData: FormData,
    userName: string,
    lotNumber: string,
  ): Observable<IParkerImportErrors[]> {
    let parkerImportError: IParkerImportErrors[] = [];

    const httpOptionsFileImport = {
      headers: new HttpHeaders({
        observe: 'events',
        responseType: 'text',
        userName: userName,
        lotNumber: lotNumber,
      }),
    };

    return this.http
      .post<
        IParkerImportErrors[]
      >(`${this.baseUrl}${this.fileUrl}/uploadparkerprofiles`, formData, httpOptionsFileImport)
      .pipe(catchError(this.handleError));

    //   subscribe({
    //     next: (event) => {
    //     if (event.type === HttpEventType.UploadProgress){
    //     }
    //     else if (event.type === HttpEventType.Response) {
    //       parkerImportError = ;
    //     }
    //   },
    //   error: (err: HttpErrorResponse) => {

    //   }
    // });
  }

  public upload(formData: FormData) {
    return this.http.post(`${this.baseUrl}${this.fileUrl}/upload`, formData, {
      reportProgress: true,
      observe: 'events',
    });
  }

  // public downloadParkerFileWithCurrentQuery(fileUrl: string, parkerQueryData: IParkerProfileDetail[]) {
  //   return this.http.post(`${this.baseUrl}${this.fileUrl}/DownloadParkerProfileDataWithQueryData?fileUrl=${fileUrl}`, parkerQueryData, {
  //     reportProgress: true,
  //     observe: 'events',
  //     responseType: 'blob'
  //   }).pipe(catchError(this.handleError));
  // }

  // public download(fileUrl: string) {
  //   return this.http.get(`${this.url}/mzdownload?fileUrl=${fileUrl}`, {
  //     reportProgress: true,
  //     observe: 'events',
  //     responseType: 'blob'
  //   });
  // }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof Error) {
      console.error('Error thrown: ' + JSON.stringify(error));
      const errMessage = error.error.message;
      return throwError(() => errMessage);
      // Use the following instead if using lite-server
      // return Observable.throw(err.text() || 'backend server error');
    }
    return throwError(() => error || 'server error');
  }
}
